import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=2f4d7358&scoped=true&"
import script from "./Bread.vue?vue&type=script&lang=js&"
export * from "./Bread.vue?vue&type=script&lang=js&"
import style0 from "./Bread.vue?vue&type=style&index=0&id=2f4d7358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d7358",
  null
  
)

export default component.exports